<template>
    <div id="add-salary-commission-content" class="h-full flex flex-col justify-between add-salary-commission-content">
        <div style="margin-bottom: 40px;">
            <!-- <h5 class="font-bold pt-6 pb-3">Salary by period</h5> -->
            <div class="flex align-center pt-6 pb-5">
                <vs-radio v-model="salary_type" :vs-value="0" class="mr-base"><h5 class="font-bold ml-2">Salary by period</h5></vs-radio>
                <vs-radio v-model="salary_type" :vs-value="1"><h5 class="font-bold ml-2">Wage per hour</h5></vs-radio>
            </div>
            <vs-input v-model="salaryValue" v-on:keypress="isNumber($event, salaryValue)"></vs-input>


            <h5 class="font-bold pt-base mt-3">Choose Employee - Owner Commission</h5>

            <p class="text-lg pt-4 pb-2">For Service</p>
            <div class="my-radio-list flex">
                <div v-for="(item, index) in serviceCommission" :key="index">
                    <vs-button type="border" class="text-lg percentage-btn" :class="{'active': service_selected.id == item.id}" @click="selectItem(item)">
                        <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                        <span v-else-if="item.end == -1">Other</span>
                        <span v-else>{{item.start}} - {{item.end}}</span>
                    </vs-button>
                </div>
            </div>

            <p class="text-lg pt-6 pb-2">For Product</p>
            <div class="my-radio-list flex">
                <div v-for="(item, index) in productCommission" :key="index">
                    <vs-button type="border" class="text-lg percentage-btn" :class="{'active': product_selected.id == item.id}" @click="selectItem(item)">
                        <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                        <span v-else-if="item.end == -1">Other</span>
                        <span v-else>{{item.start}} - {{item.end}}</span>
                    </vs-button>
                </div>
            </div>

            <p class="text-lg pt-6 pb-2">For Giftcard</p>
            <div class="my-radio-list flex">
                <div v-for="(item, index) in giftcardCommission" :key="index">
                    <vs-button type="border" class="text-lg percentage-btn" :class="{'active': giftcard_selected.id == item.id}" @click="selectItem(item)">
                        <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                        <span v-else-if="item.end == -1">Other</span>
                        <span v-else>{{item.start}} - {{item.end}}</span>
                    </vs-button>
                </div>
            </div>

            <div class="flex items-center pt-base mt-3 pb-5">
                <h5 class="font-bold mr-8">Choose Cash - Check Proportion</h5>

                <ul class="centerx flex align-center justify-between space-x-8">
                    <li class="flex items-center">
                        <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="percent">%</vs-radio>
                    </li>
                    <li class="flex items-center">
                        <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="usd">$</vs-radio>
                    </li>
                </ul>
            </div>
            <div class="my-radio-list flex" v-if="cashCheckType == 'percent'">
                <div v-for="(item, index) in cashCheckPercentage" :key="index">
                    <vs-button type="border" class="text-lg percentage-btn" :class="{'active': cashcheck_selected.id == item.id}" @click="selectItem(item)">
                        <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                        <span v-else-if="item.end == -1">Other</span>
                        <span v-else>{{item.start}} - {{item.end}}</span>
                    </vs-button>
                </div>
            </div>
            <div v-else>
                <div class="flex items-center">
                    <div class="fixed-cash-check-type-select">
                        <v-select @input="selectFixedCashCheckType($event)" :value="fixedCashCheckType" label="name" :options="fixedCashCheckTypeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    </div>
                    <vs-input class="fixed-cash-check-type-input" v-model="fixedCashCheckValue" v-on:keypress="isNumber($event, fixedCashCheckValue)"></vs-input>
                </div>
            </div>

            <div>
                <h5 class="font-bold pt-base mt-3 pb-3">Deduction Per Day</h5>
                <vs-input v-model="deductionPerDay" v-on:keypress="isNumber($event, deductionPerDay)"></vs-input>
            </div>

            <div class="flex w-full">
                <div>
                    <h5 class="font-bold pt-base mt-1 pb-3">Card Charge(%)</h5>
                    <vs-input v-model="cardCharge" v-on:keypress="isNumber($event, cardCharge)"></vs-input>
                </div>
                <!-- <div class="cash-charge-margin">
                    <h5 class="font-bold pt-base mt-3 pb-3">Cash Bonus(%)</h5>
                    <vs-input v-model="cashCharge" v-on:keypress="isNumber($event, cashCharge)"></vs-input>
                </div> -->
            </div>


            <p class='text-grey-custom mt-5 mb-base'>Do you want your employees to share credit card fees with you by withdrawing a percentage from the commission?</p>

            <div class="mb-base flex">
                <div class="flex align-start">
                    <vs-switch class="credit-card-tip" v-model="creditCardTip" />
                    <span @click="creditCardTip = !creditCardTip" class="pl-6 cursor-pointer font-bold color-black" :class="{'text-primary': creditCardTip}" style="font-size: 15.96px">Credit card tips added to check</span>
                </div>

                <div class="percentage-charge-margin">
                    <h5 class="font-bold pb-3">Percentage charge(%)</h5>
                    <vs-input v-model="percentageCharge" v-on:keypress="isNumber($event, percentageCharge)" :disabled="creditCardTip == false"></vs-input>
                </div>
            </div>

            <div class="mb-base">
                <div class="flex align-start">
                    <vs-switch class="credit-card-tip" v-model="countDayOff" />
                    <span @click="countDayOff = !countDayOff" class="pl-6 cursor-pointer font-bold color-black" :class="{'text-primary': countDayOff}" style="font-size: 15.96px; width: max-content">Count days off</span>
                </div>

                <div class="mt-5 day-off-content" :class="{'day-off-error' : day_off_err}">
                    <div class="max-day-off-margin">
                        <h5 class="font-bold pb-3">Maximum days allowed to be off</h5>
                        <vs-input v-model="countDayOffNumber" v-on:keypress="isDayNumber($event)" :disabled="countDayOff == false"></vs-input>
                    </div>
                    <div class="day-off-margin">
                        <h5 class="font-bold pb-3">Days not allowed to be off</h5>
                        <div class="flex">
                            <vs-button type="border" class="user-select-none day-off-btn" v-for="(day, index) in dayOfWeekList" :key="index" :class="{'active': day.isActive}"
                                @click="updateActiveDayOff(index)" :disabled="countDayOff == false">
                                {{day.title}}
                            </vs-button>
                        </div>
                    </div>
                </div>

                <p class="max-day-off-margin mt-6 day-off-error-text" v-if="day_off_err">** You must fill at least one option above</p>
            </div>
        </div>

        <div class="flex justify-center py-6 bg-white border-top-custom bottom-group-btn">
            <vs-button color="danger" type="border" class="commission-btn mr-4" @click="closeSidebar">Cancel</vs-button>
            <vs-button class="commission-btn" @click="saveSalaryCommission">Save</vs-button>
        </div>

        <vs-popup class="holamundo customize-percentage-popup" :title="customType == 'cashcheck' ? 'Customize Cash - Check Percentage' :'Customize Employee - Owner Percentage'" :active.sync="popupActive">
            <div class="text-center">
                <!-- <h3>Do you want to delete this staff?</h3> -->
                <div class="flex align-center mb-4">
                    <p class="w-1/2 text-left" v-if="customType == 'cashcheck'">Percent for Cash</p>
                    <p class="w-1/2 text-left" v-else>Percent for Employee</p>
                    <vs-input class="" v-model="customPercentage" v-on:keypress="isTwoDigitsAfterDecimalNumber($event, customPercentage)" />
                </div>

                <div class="flex align-center mb-4">
                     <p class="w-1/2 text-left" v-if="customType == 'cashcheck'">Percent for Check</p>
                    <p class="w-1/2 text-left" v-else>Percent for Owner</p>
                    <vs-input class="" :value="formatPercentToShow(100 - customPercentage)" disabled />
                </div>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                    <vs-button type="border" color="danger" class="mr-6 cancel-responsive" @click="popupActive = false">Cancel</vs-button>
                    <vs-button class="align-center delete-responsive" @click="saveOtherValue">Ok</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: 'update-salary-commission-content',
    components: { vSelect },
    props: {
      commissionList:{
        type : Object,
        required: true
      }
    },
    data() {
        let serviceCommission = [];
        let productCommission = [];
        let giftcardCommission = [];
        let cashCheckPercentage = [];
        
        let dayOfWeekList = [];

        let service_selected = null;
        let product_selected = null;
        let giftcard_selected = null;
        let cashcheck_selected = null;

        let creditCardTip = 0;

        let countDayOff = 0;

        let cashCheckType = "percent";
        let deductionPerDay = 0;
        let fixedCashCheckType = "Cash";
        let fixedCashCheckValue = 0;

        this.getData();

        // let serviceCommission = [
        //   {id: 1, start: 70, end: 30, name: '70-30', type: 'service'},
        //   {id: 2, start: 60, end: 40, name: '60-40', type: 'service'},
        //   {id: 3, start: 50, end: 50, name: '50-50', type: 'service'},
        //   {id: 4, start: 40, end: 60, name: '40-60', type: 'service'},
        //   {id: 5, start: 0, end: 100, name: '0-100', type: 'service'},
        //   {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
        // ];
        // let productCommission = [
        //   {id: 1, start: 70, end: 30, name: '70-30', type: 'product'},
        //   {id: 2, start: 60, end: 40, name: '60-40', type: 'product'},
        //   {id: 3, start: 50, end: 50, name: '50-50', type: 'product'},
        //   {id: 4, start: 40, end: 60, name: '40-60', type: 'product'},
        //   {id: 5, start: 0, end: 100, name: '0-100', type: 'product'},
        //   {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
        // ];
        // let giftcardCommission = [
        //   {id: 1, start: 70, end: 30, name: '70-30', type: 'giftcard'},
        //   {id: 2, start: 60, end: 40, name: '60-40', type: 'giftcard'},
        //   {id: 3, start: 50, end: 50, name: '50-50', type: 'giftcard'},
        //   {id: 4, start: 40, end: 60, name: '40-60', type: 'giftcard'},
        //   {id: 5, start: 0, end: 100, name: '0-100', type: 'giftcard'},
        //   {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
        // ];
        // let cashCheckPercentage = [
        //   {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
        //   {id: 2, start: 60, end: 40, name: '60-40', type: 'cashcheck'},
        //   {id: 3, start: 50, end: 50, name: '50-50', type: 'cashcheck'},
        //   {id: 4, start: 40, end: 60, name: '40-60', type: 'cashcheck'},
        //   {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
        // ]

        // let service_selected = serviceCommission[0];
        // let product_selected = productCommission[0];
        // let giftcard_selected = giftcardCommission[0];
        // let cashcheck_selected = cashCheckPercentage[0];

        // if(this.commissionList && this.commissionList.salary_commission){
        //   for(let i = 0; i < serviceCommission.length; i++){
        //     if(serviceCommission[i].start == this.commissionList.salary_commission.service_rate*100){
        //       service_selected = serviceCommission[i];
        //       break;
        //     }
        //     if(i == serviceCommission.length - 1){
        //       service_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
        //       serviceCommission[serviceCommission.length - 1] = {id: 6, start: this.commissionList.salary_commission.service_rate*100, end: 100 - this.commissionList.salary_commission.service_rate*100, name: 'other', type: 'service'}
        //     }
        //   }

        //   for(let i = 0; i < productCommission.length; i++){
        //     if(productCommission[i].start == this.commissionList.salary_commission.product_rate*100){
        //       product_selected = productCommission[i];
        //       break;
        //     }
        //     if(i == productCommission.length - 1){
        //       product_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
        //       productCommission[productCommission.length - 1] = {id: 6, start: this.commissionList.salary_commission.product_rate*100, end: 100 - this.commissionList.salary_commission.product_rate*100, name: 'other', type: 'service'}
        //     }
        //   }

        //   for(let i = 0; i < giftcardCommission.length; i++){
        //     if(giftcardCommission[i].start == this.commissionList.salary_commission.gift_card_rate*100){
        //       giftcard_selected = giftcardCommission[i];
        //       break;
        //     }
        //     if(i == giftcardCommission.length - 1){
        //       giftcard_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
        //       giftcardCommission[giftcardCommission.length - 1] = {id: 6, start: this.commissionList.salary_commission.gift_card_rate*100, end: 100 - this.commissionList.salary_commission.gift_card_rate*100, name: 'other', type: 'service'}
        //     }
        //   }

        //   for(let i = 0; i < cashCheckPercentage.length; i++){
        //     if(cashCheckPercentage[i].start == this.commissionList.salary_commission.cash_check_percentage*100){
        //       cashcheck_selected = cashCheckPercentage[i];
        //       break;
        //     }
        //     if(i == cashCheckPercentage.length - 1){
        //       cashcheck_selected = {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
        //       cashCheckPercentage[cashCheckPercentage.length - 1] = {id: 6, start: this.commissionList.salary_commission.cash_check_percentage*100, end: 100 - this.commissionList.salary_commission.cash_check_percentage*100, name: 'other', type: 'service'}
        //     }
        //   }
        // }
        // let creditCardTip = 0;
        // if(this.commissionList.salary_commission) {
        //   if(this.commissionList.salary_commission.is_tip_to_check){
        //     creditCardTip = this.commissionList.salary_commission.is_tip_to_check;
        //   }else {
        //     creditCardTip = 0;
        //   }
        // }

        let salary_type = 0;
        let salaryValue = 0;
        if(this.commissionList.salary_commission) {
            salary_type = this.commissionList.salary_commission.salary_type;
            if(salary_type == 0) {
                salaryValue = this.commissionList.salary_commission.salary_by_period ? this.formatSalaryNumber(this.commissionList.salary_commission.salary_by_period) : 0;
            } else {
                salaryValue = this.commissionList.salary_commission.salary_per_hour ? this.formatSalaryNumber(this.commissionList.salary_commission.salary_per_hour) : 0;
            }
        }

        return {
            serviceCommission,
            productCommission,
            giftcardCommission,
            cashCheckPercentage,
            cardCharge: this.commissionList.salary_commission ? this.formatFloatNum(this.commissionList.salary_commission.card_charge) : 0,
            // cashCharge: this.commissionList.salary_commission ? this.commissionList.salary_commission.cash_charge*100 : 0,
            creditCardTip: creditCardTip == 1 ? true : false,
            countDayOff: countDayOff == 1 ? true : false,
            percentageCharge: this.commissionList.salary_commission ? this.formatFloatNum(this.commissionList.salary_commission.tip_to_check_percentage) : 0,
            salaryValue,
            salary_type,
            countDayOffNumber: this.commissionList.salary_commission ? this.commissionList.salary_commission.count_day_off_value : '',

            service_selected,
            product_selected,
            giftcard_selected,
            cashcheck_selected,

            active_item: null,

            popupActive: false,
            customPercentage: 0,
            // customPercentage_temp: 0,
            customType: '',
            dayOfWeekList,
            day_off_err: false,
            cashCheckType,
            fixedCashCheckType,
            fixedCashCheckValue,
            deductionPerDay,
            fixedCashCheckTypeOptions: [
                {
                    id: 1,
                    name: 'Cash'
                },
                {
                    id: 2,
                    name: 'Check'
                },
            ]
        }
    },
    watch: {
        commissionList: {
            immediate: true,
            deep: true,
            handler() {
                this.getData();
            }
        }
    },
    methods: {
        formatPercent(value) {
            // return Math.round((value/100) * 100 + Number.EPSILON ) / 100;
            return +(Math.round(value*100 + "e+2") + "e-2");
        },
        formatPercentToShow(value) {
            return +(Math.round(value + "e+2") + "e-2");
        },
        formatPercentToPost(value) {
            return +(Math.round(value/100 + "e+4") + "e-4");
        },
        formatFloatNumToPost(value) {
            return +(Math.round(value/100 + "e+7") + "e-7");
        },
        formatFloatNum(value) {
            return +(Math.round(value*100 + "e+5") + "e-5");
        },
        formatSalaryNumber(value) {
            return +(Math.round(value + "e+3") + "e-3");
        },
        getData() {
            this.serviceCommission = [
                {id: 1, start: 70, end: 30, name: '70-30', type: 'service'},
                {id: 2, start: 60, end: 40, name: '60-40', type: 'service'},
                {id: 3, start: 50, end: 50, name: '50-50', type: 'service'},
                {id: 4, start: 40, end: 60, name: '40-60', type: 'service'},
                {id: 5, start: 0, end: 100, name: '0-100', type: 'service'},
                {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
            ];
            this.productCommission = [
                {id: 1, start: 70, end: 30, name: '70-30', type: 'product'},
                {id: 2, start: 60, end: 40, name: '60-40', type: 'product'},
                {id: 3, start: 50, end: 50, name: '50-50', type: 'product'},
                {id: 4, start: 40, end: 60, name: '40-60', type: 'product'},
                {id: 5, start: 0, end: 100, name: '0-100', type: 'product'},
                {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
            ];
            this.giftcardCommission = [
                {id: 1, start: 70, end: 30, name: '70-30', type: 'giftcard'},
                {id: 2, start: 60, end: 40, name: '60-40', type: 'giftcard'},
                {id: 3, start: 50, end: 50, name: '50-50', type: 'giftcard'},
                {id: 4, start: 40, end: 60, name: '40-60', type: 'giftcard'},
                {id: 5, start: 0, end: 100, name: '0-100', type: 'giftcard'},
                {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
            ];
            this.cashCheckPercentage = [
                {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
                {id: 2, start: 60, end: 40, name: '60-40', type: 'cashcheck'},
                {id: 3, start: 50, end: 50, name: '50-50', type: 'cashcheck'},
                {id: 4, start: 40, end: 60, name: '40-60', type: 'cashcheck'},
                {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
            ];
            this.dayOfWeekList = [
                { title: 'MON', value: 'Monday', isActive: false },
                { title: 'TUE', value: 'Tuesday', isActive: false },
                { title: 'WED', value: 'Wednesday', isActive: false },
                { title: 'THU', value: 'Thursday', isActive: false },
                { title: 'FRI', value: 'Friday', isActive: false },
                { title: 'SAT', value: 'Saturday', isActive: false },
                { title: 'SUN', value: 'Sunday', isActive: false }
            ];

            this.service_selected = this.serviceCommission[0];
            this.product_selected = this.productCommission[0];
            this.giftcard_selected = this.giftcardCommission[0];
            this.cashcheck_selected = this.cashCheckPercentage[0];

            if(this.commissionList && this.commissionList.salary_commission){
                for(let i = 0; i < this.serviceCommission.length; i++){
                    if(this.serviceCommission[i].start == this.formatPercent(this.commissionList.salary_commission.service_rate)){
                        this.service_selected = this.serviceCommission[i];
                        break;
                    }
                    if(i == this.serviceCommission.length - 1){
                        // this.service_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
                        this.serviceCommission[this.serviceCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.service_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.service_rate), name: 'other', type: 'service'}
                        this.service_selected = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.service_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.service_rate), name: 'other', type: 'service'};
                    }
                }

                for(let i = 0; i < this.productCommission.length; i++){
                    if(this.productCommission[i].start == this.formatPercent(this.commissionList.salary_commission.product_rate)){
                        this.product_selected = this.productCommission[i];
                        break;
                    }
                    if(i == this.productCommission.length - 1){
                        // this.product_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
                        this.productCommission[this.productCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.product_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.product_rate), name: 'other', type: 'product'}
                        this.product_selected = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.product_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.product_rate), name: 'other', type: 'product'};
                    }
                }

                for(let i = 0; i < this.giftcardCommission.length; i++){
                    if(this.giftcardCommission[i].start == this.formatPercent(this.commissionList.salary_commission.gift_card_rate)){
                        this.giftcard_selected = this.giftcardCommission[i];
                        break;
                    }
                    if(i == this.giftcardCommission.length - 1){
                        // this.giftcard_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
                        this.giftcardCommission[this.giftcardCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.gift_card_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.gift_card_rate), name: 'other', type: 'giftcard'}
                        this.giftcard_selected = {id: 6, start: this.formatPercent(this.commissionList.salary_commission.gift_card_rate), end: this.formatPercent(1 - this.commissionList.salary_commission.gift_card_rate), name: 'other', type: 'giftcard'};
                    }
                }

                for(let i = 0; i < this.cashCheckPercentage.length; i++){
                    if(this.cashCheckPercentage[i].start == this.formatPercent(this.commissionList.salary_commission.cash_check_percentage)){
                        this.cashcheck_selected = this.cashCheckPercentage[i];
                        break;
                    }
                    if(i == this.cashCheckPercentage.length - 1){
                        // this.cashcheck_selected = {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
                        this.cashCheckPercentage[this.cashCheckPercentage.length - 1] = {id: 5, start: this.formatPercent(this.commissionList.salary_commission.cash_check_percentage), end: this.formatPercent(1 - this.commissionList.salary_commission.cash_check_percentage), name: 'other', type: 'cashcheck'}
                        this.cashcheck_selected = {id: 5, start: this.formatPercent(this.commissionList.salary_commission.cash_check_percentage), end: this.formatPercent(1 - this.commissionList.salary_commission.cash_check_percentage), name: 'other', type: 'cashcheck'};
                    }
                }

                if(this.commissionList.salary_commission.day_can_not_off) {
                    let day_off_arr = JSON.parse(this.commissionList.salary_commission.day_can_not_off);
                    if(day_off_arr) {
                        for(let i = 0; i < this.dayOfWeekList.length; i++) {
                            for(let j = 0; j < day_off_arr.length; j++) {
                                if(this.dayOfWeekList[i].value.toLowerCase() == day_off_arr[j].toLowerCase()) {
                                    this.dayOfWeekList[i].isActive = true;
                                    j = day_off_arr.length;
                                }
                            }
                        }
                    }
                }

                this.cashCheckType = this.commissionList.salary_commission.is_fixed_amount == 1 ? "usd" : "percent";
                this.fixedCashCheckType = this.commissionList.salary_commission.check_fixed_amount ? "Check" : "Cash";
                this.fixedCashCheckValue = this.commissionList.salary_commission.cash_fixed_amount || this.commissionList.salary_commission.check_fixed_amount;
                this.deductionPerDay = this.commissionList.salary_commission.deduction_per_day;
            }
            this.creditCardTip = 0;
            this.countDayOff = 0;
            this.salary_type = 0;
            this.salaryValue = 0;
            if(this.commissionList.salary_commission) {
                if(this.commissionList.salary_commission.is_tip_to_check){
                    this.creditCardTip = this.commissionList.salary_commission.is_tip_to_check;
                } else {
                    this.creditCardTip = 0;
                }

                if(this.commissionList.salary_commission.count_day_off_state) {
                    this.countDayOff = this.commissionList.salary_commission.count_day_off_state;
                } else {
                    this.countDayOff = 0;
                }
                this.salary_type = this.commissionList.salary_commission.salary_type;
                if(this.salary_type == 0) {
                    this.salaryValue = this.commissionList.salary_commission.salary_by_period ? this.formatSalaryNumber(this.commissionList.salary_commission.salary_by_period) : 0;
                } else {
                    this.salaryValue = this.commissionList.salary_commission.salary_per_hour ? this.formatSalaryNumber(this.commissionList.salary_commission.salary_per_hour) : 0;
                }
            }

            this.cardCharge = this.commissionList.salary_commission ? this.formatFloatNum(this.commissionList.salary_commission.card_charge) : 0;
            this.creditCardTip = this.creditCardTip == 1 ? true : false;
            this.percentageCharge = this.commissionList.salary_commission ? this.formatFloatNum(this.commissionList.salary_commission.tip_to_check_percentage) : 0;
            // this.salaryValue = this.commissionList.salary_commission ? this.formatSalaryNumber(this.commissionList.salary_commission.salary_by_period) : 0;

            this.countDayOff = this.countDayOff == 1 ? true : false;
            this.countDayOffNumber = this.commissionList.salary_commission ? this.commissionList.salary_commission.count_day_off_value : '';

            this.active_item = null;
            this.customPercentage = 0;
            this.customType = ''; 
            this.day_off_err = false;
        },
        getListDayNotOff() {
            let result = [];
            if(this.dayOfWeekList) {
                for(let i = 0; i < this.dayOfWeekList.length; i++) {
                    if(this.dayOfWeekList[i].isActive) {
                        result.push(this.dayOfWeekList[i].value);
                    }
                }
            }
            return JSON.stringify(result);
        },
        saveSalaryCommission() {
            if(this.cashCheckType != "percent" && (!this.fixedCashCheckValue || this.fixedCashCheckValue == "0")) {
                this.$vs.notify({
                    title:'Notification',
                    text:'Fixed amount must be greater than 0',
                    color:'danger',
                    position:'top-right'
                });
                return;
            }
            const obj = {
                type: 'salary_commission',
                salary_type: this.salary_type,
                // salary_by_period: this.formatSalaryNumber(this.salaryValue),
                service_rate: this.formatPercentToPost(this.service_selected.start),
                product_rate: this.formatPercentToPost(this.product_selected.start),
                gift_card_rate: this.formatPercentToPost(this.giftcard_selected.start),
                cash_check_percentage: this.formatPercentToPost(this.cashcheck_selected.start),
                card_charge: this.formatFloatNumToPost(this.cardCharge),
                // cash_charge: this.formatPercent(this.cashCharge),
                is_tip_to_check: this.creditCardTip ? 1 : 0,
                tip_to_check_percentage: this.creditCardTip ? this.formatFloatNumToPost(this.percentageCharge) : 0,
                count_day_off_state: this.countDayOff ? 1 : 0,
                deduction_per_day: this.deductionPerDay ? this.deductionPerDay : 0,
                cash_fixed_amount: this.fixedCashCheckType == "Cash" ? this.fixedCashCheckValue : 0,
                check_fixed_amount: this.fixedCashCheckType == "Check" ? this.fixedCashCheckValue : 0,
                is_fixed_amount: this.cashCheckType == "percent" ? 0 : 1
                // count_day_off_value: this.countDayOffNumber ? this.countDayOffNumber : '',
                // day_can_not_off: this.getListDayNotOff()
            }
            if(this.salary_type == 0) {
                obj.salary_by_period = this.formatSalaryNumber(this.salaryValue);
            } else {
                obj.salary_per_hour = this.formatSalaryNumber(this.salaryValue);
            }
            if(obj.count_day_off_state) {
                obj.count_day_off_value = this.countDayOffNumber != null ? this.countDayOffNumber : '';
                obj.day_can_not_off = this.getListDayNotOff();
                if(obj.count_day_off_value === '' && obj.day_can_not_off == '[]') {
                    this.day_off_err = true;
                } else {
                    this.$emit("SaveSalaryCommission", obj);
                }
            } else {
                this.$emit("SaveSalaryCommission", obj);
            }
        },
        selectItem(item) {
            if(item) {
                if(item.name != 'other') {
                    if(item.type == 'service') {
                        this.service_selected = item;
                    } else if (item.type == 'product') {
                        this.product_selected = item;
                    } else if (item.type == 'giftcard') {
                        this.giftcard_selected = item;
                    } else {
                        this.cashcheck_selected = item;
                    }
                } else {
                    this.active_item = item;
                    this.customPercentage = item.start;
                    this.customType = item.type;
                    this.popupActive = true;
                }
            }
        },
        isNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isIntegerNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                if(parseInt(this.customPercentage + '' + evt.key) <= 100) {
                    return true;
                } else {
                    evt.preventDefault();
                }
            }
        },
        isTwoDigitsAfterDecimalNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && num.toString().indexOf(".") != -1 && (num.toString().substring(num.toString().indexOf(".") + 1)).length == 2) || 
            ((charCode >= 48 && charCode <= 57) && parseFloat(num + '' + String.fromCharCode(charCode)) > 100)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isDayNumber: function(evt) {
            this.day_off_err = false;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        outConfiguration() {
            this.$emit('OutConfiguration');
        },
        saveOtherValue() {
            if(this.customPercentage == '') {
                this.customPercentage = 0;
            }
            if(this.customType == 'service') {
                this.service_selected = this.active_item;
                this.service_selected.start = this.formatPercentToShow(this.customPercentage);
                this.service_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else if (this.customType == 'product') {
                this.product_selected = this.active_item;
                this.product_selected.start = this.formatPercentToShow(this.customPercentage);
                this.product_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else if (this.customType == 'giftcard') {
                this.giftcard_selected = this.active_item;
                this.giftcard_selected.start = this.formatPercentToShow(this.customPercentage);
                this.giftcard_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else {
                this.cashcheck_selected = this.active_item;
                this.cashcheck_selected.start = this.formatPercentToShow(this.customPercentage);
                this.cashcheck_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            }
            this.popupActive = false;
        },
        closeSidebar() {
            this.$emit('closeSidebar');
        },
        updateActiveDayOff(index) {
            if(this.dayOfWeekList && this.dayOfWeekList[index]) {
                this.day_off_err = false;
                this.dayOfWeekList[index].isActive = !this.dayOfWeekList[index].isActive;
            }
        },
        selectFixedCashCheckType(e) {
            this.fixedCashCheckType = e.name;
        },
    }
}
</script>
